<script>
    import { fly } from "svelte/transition";
    import { Swiper, SwiperItem } from "../index";

    function handleClick(){
        //  跳转 打点...
    }
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body bg">
        <Swiper>
            <SwiperItem
            on:click={()=>handleClick()}
                title="8.88元满减支付券来了"
                text="4月12日 9:00开奖"
                btnTxt="去使用"
                icon="https://ts.market.mi-img.com/thumbnail/png/q80/Finance/0384cd523486d439bb22ea30405c013680a4ec79a"
            />
            <SwiperItem
                title="8.89元满减支付券来了"
                text="4月12日 9:00开奖"
                btnTxt="去使用"
                icon="https://ts.market.mi-img.com/thumbnail/png/q80/Finance/0384cd523486d439bb22ea30405c013680a4ec79a"
            />
            <SwiperItem
                title="890元满减支付券来了"
                text="4月12日 9:00开奖"
                btnTxt="去使用"
                icon="https://ts.market.mi-img.com/thumbnail/png/q80/Finance/0384cd523486d439bb22ea30405c013680a4ec79a"
            />
        </Swiper>
    </div>
    <h4 class="example-title">只有一张图</h4>
    <div class="example-body bg">
        <Swiper autoplay>
            <SwiperItem
            on:click={()=>handleClick()}
                title="8.88元满减支付券来了"
                text="4月12日 9:00开奖"
                btnTxt="去使用"
                icon="https://ts.market.mi-img.com/thumbnail/png/q80/Finance/0384cd523486d439bb22ea30405c013680a4ec79a"
            />
        </Swiper>
    </div>
    <h4 class="example-title">反白</h4>
    <div class="example-body bg">
        <Swiper --swiper-bg-color="#005CFF" --swiper-color-text="#fff">
            <SwiperItem
                title="8.88元满减支付券来了"
                text="4月12日 9:00开奖"
                btnTxt="去使用"
                icon="https://ts.market.mi-img.com/thumbnail/png/q80/Finance/0384cd523486d439bb22ea30405c013680a4ec79a"
            />
            <SwiperItem
                title="8.89元满减支付券来了"
                text="4月12日 9:00开奖"
                btnTxt="去使用"
                icon="https://ts.market.mi-img.com/thumbnail/png/q80/Finance/0384cd523486d439bb22ea30405c013680a4ec79a"
            />
            <SwiperItem
                title="890元满减支付券来了"
                text="4月12日 9:00开奖"
                btnTxt="去使用"
                icon="https://ts.market.mi-img.com/thumbnail/png/q80/Finance/0384cd523486d439bb22ea30405c013680a4ec79a"
            />
        </Swiper>
    </div>
    <h4 class="example-title">自定义</h4>
    <div class="example-body bg">
        <Swiper --swiper-bg-color="#005CFF" --swiper-color-text="#fff">
            <SwiperItem>
                <div class="rect">1111</div>
            </SwiperItem>
            <SwiperItem>
                <div class="rect">22222</div>
            </SwiperItem>
            <SwiperItem>
                <div class="rect">33333</div>
            </SwiperItem>
        </Swiper>
    </div>

    <h4 class="example-title">自动播放</h4>
    <div class="example-body bg">
        <Swiper autoplay>
            <SwiperItem
                title="8.88元满减支付券来了"
                text="4月12日 9:00开奖"
                btnTxt="去使用"
                icon="https://ts.market.mi-img.com/thumbnail/png/q80/Finance/0384cd523486d439bb22ea30405c013680a4ec79a"
            />
            <SwiperItem
                title="8.89元满减支付券来了"
                text="4月12日 9:00开奖"
                btnTxt="去使用"
                icon="https://ts.market.mi-img.com/thumbnail/png/q80/Finance/0384cd523486d439bb22ea30405c013680a4ec79a"
            />
            <SwiperItem
                title="890元满减支付券来了"
                text="4月12日 9:00开奖"
                btnTxt="去使用"
                icon="https://ts.market.mi-img.com/thumbnail/png/q80/Finance/0384cd523486d439bb22ea30405c013680a4ec79a"
            />
        </Swiper>
    </div>
</div>

<style lang="less">
    @import "./example.less";
    .bg {
        background-color: #eee;
    }
    .rect {
        height: 90px;
        font-size: 23px;
        background-color: green;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
